const tapAlternativeLocationCategories = Object.freeze({
  ResourceRoom: 1,
  SpecialRoomSEP: 2,
  SpecialRoomSEM: 3,
  Home: 4,
  Itinerant: 5,
  ProviderOffice: 6,
  TherapyRoom: 7,
});
export default tapAlternativeLocationCategories;
